module.exports = __webpack_public_path__ + "static/media/768px-Nivea_logo.svg.5204d379.png";